<template>
  <v-container fluid class="d-flex flex-column" >
    <v-tabs v-model="tab" grow show-arrows slider-color="#E9282A" v-if="isDashboardRoute">
      <v-tab
        v-for="(tabKey, index) in Object.keys(tabs)"
        :key="index"
        :value="tabKey"
        :disabled="isTabDisabled(tabKey)"
        nuxt="true"
        :to="`/dashboard/${tabKey}`"
        :class="{ 'selected-tab': tabIsSelected(tabKey), 'unselected-tab': !tabIsSelected(tabKey) }"
      >
        {{ tabs[tabKey].title }}
      </v-tab>
    </v-tabs>

    <slot />
  </v-container>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { useUser } from '~/composables/useUser'; 
import { useTenant } from '~/composables/useTenant'; 
import { useTabStore } from '~/stores/useTabStore';

const tabStore = useTabStore();
const tabs = {
  overall: { title: "Overall" },
  eia: { title: "Environmental" },
  ems: { title: "EMS" },
  renewable: { title: "Renewable" },
  assets: { title: "Security" },
  hcm: { title: "HCM" },
  mfg: { title: "MFG" },
  // swiflet: { title: "Swiflet" },
};

const tenantModules = ref<string[]>([]);
const route = useRoute();
const router = useRouter();
const tab = ref('overall'); // Set the default tab

const isDashboardRoute = computed(() => route.path.startsWith('/dashboard'));

const initializeTabFromPath = () => {
  const currentPath = route.path.split('/').pop(); 
  if (Object.keys(tabs).includes(currentPath)) {
    tab.value = currentPath;
  } else {
    tab.value = 'overall'; 
  }
};

onMounted(async () => {
  initializeTabFromPath();

  const user = await useUser();
  const tenantId = user.value?.tenant?.id;

  if (tenantId) {
    const tenant = await useTenant(tenantId);
    tenantModules.value = tenant.value?.modules || [];
   
      initializeTabFromPath();
    
  }
});

watch(() => route.path, (newPath) => {
  const newTab = newPath.split('/').pop(); 
  if (newTab && Object.keys(tabs).includes(newTab)) {
    tab.value = newTab;
  } else {
    tab.value = 'overall'; 
  }
});

watch(tab, (newTab) => {
  if(newTab && Object.keys(tabs).includes(newTab) && isDashboardRoute.value){
    router.push({ path: `/dashboard/${newTab}` });
  }
});

const tabIsSelected = (value: string) => {
  return tab.value === value;
};

const isTabDisabled = (value: string) => {
  return value !== 'overall' && !tenantModules.value.includes(tabs[value].title);
};
</script>

<style scoped>
.v-tabs,
.v-tab {
  font-family: 'Nunito Sans', sans-serif;
}

.selected-tab {
  color: #fff !important;
  background-color: #E9282A;
  font-weight: 700 !important;

}
.unselected-tab:hover {
  background-color: #eb9596 !important;
  color: #fff !important;
}
.unselected-tab {
  color: #808b95;
  font-weight: bold;
}
</style>